import fixPhone from './fixPhone';

const BLR = /^\+375\d{9}$/;
const KAZ = /^\+77(?!07)\d{9}$/;
const RUS = /^(8|\+7)9\d{9}$/;
const TKM = /^\+9936\d{7}$/;
const UZB = /^\+998\d{9}$/;

const SUPPORTED_PHONES = [BLR, KAZ, RUS, TKM, UZB];

export function isSupported(phone) {
    phone = fixPhone(phone);

    for (const regExp of SUPPORTED_PHONES) {
        if (regExp.test(phone)) {
            return true;
        }
    }

    return false;
}
